/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {HttpBackend, HttpClient} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {TranslateLoader} from '@ngx-translate/core';
import {Observable} from 'rxjs';

@Injectable()
export class HttpTranslateLoader implements TranslateLoader {
  // HttpBackend bypasses all interceptors, preventing a circular dependency
  // between the interceptors and the translate loader.
  private http = new HttpClient(inject(HttpBackend));

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`./assets/i18n/${lang}.json`);
  }
}
